import { render, staticRenderFns } from "./openExperience.vue?vue&type=template&id=34d63c59&"
import script from "./openExperience.vue?vue&type=script&lang=js&"
export * from "./openExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports